import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { validateForm } from "utils/validation";
import Spinner from "Common/Globle/Spinner";
import EditLaundryItemCostForm from "./Componates/EditLaundryItemCostForm";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";
import useFetchAllData from "Hooks/useFetchAllData";
import { LaundryItemCostRules } from "validation/ValidationRules";
import fields from "../json/LaundryItemCostFields.json";
import {
    Update,
    GetById,
    GetAllProduct,
    GetAllTask
} from "adminApi/LaundryItemCostApi/LaundryItemCost.js";

const EditLaundryItemCost = () => {

    const navigate = useNavigate();
    const { id } = useParams();
    const { formdata } = fields;

    // Initialize form values from JSON fields
    const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

    // Handle values on on change
    const {
        values,
        errors,
        handleChange,
        setErrors,
        setValues
    } = useFormChange(
        initialValues,
        LaundryItemCostRules
    );

    // Fetch existing data by ID
    const {
        loading: loadingFetch
    } = useFetchFormDataById(
        id,
        formdata,
        GetById,
        setValues
    );

    // Get Product Options
    const {
        data: ProductOptions = []
    } = useFetchAllData(
        GetAllProduct
    );

    // GetTask Options
    const {
        data: TaskOptions = []
    } = useFetchAllData(
        GetAllTask
    );

    // Form submit
    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        async (formValues) => {
            const formData = new FormData();
            Object.entries(formValues).forEach(([key, val]) => formData.append(key, val ?? ""));
            return await Update({ id, data: formData });
        },
        (vals) => {
            const err = validateForm(vals, LaundryItemCostRules)
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Laundry Item Cost Updated Successfully"
    );

    return (
        <>
            {(loadingSubmit || loadingFetch) && <Spinner isSpinner={true} />}
            <EditLaundryItemCostForm
                fields={formdata}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loadingSubmit}
                title="Edit Laundry Item Cost"
                ProductOptions={ProductOptions}
                TaskOptions={TaskOptions}
            />
        </>
    );

};

export default EditLaundryItemCost;
